/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {},
    registered(registration) {
      // 初回のみ更新チェック（定期チェックは削除）
      registration.update()
    },
    cached() {},
    updatefound() {},
    updated() {
      // 自動リロードは削除 - ユーザーが手動でリロードする
    },
    offline() {},
    error(error) {
      console.error('[OH3] Error during service worker registration:', error)
    },
  })
}
